import React, { FC, memo } from 'react'
// components
import Layout from '../Layout'
// redux
import { WrappedFieldProps } from 'redux-form'
import ReactSelect, { components as reactSelectComponents } from 'react-select'
// types
import { SelectPropsType } from 'components/Form/Fields/FieldSelect'
import { StyledComponentProps } from 'react-jss'
import { CustomOptionProps } from './CusotmOptionRecruiter'
import { CustomSingleValueProps } from './CustomSingleRecruiter'
// styles
import { colourStylesWithoutBorder, colourStyles, DropdownIndicator } from './style'
import { cssVarTextColors } from 'lib/cssSelector'
type Props = SelectPropsType &
  WrappedFieldProps &
  StyledComponentProps & {
    customOptionComponent?: React.ComponentType<CustomOptionProps>
    customSingleValueComponent?: React.ComponentType<any>
  }

const Select: FC<Props> = props => {
  const {
    title,
    // name,
    options,
    input: { value, onChange, name },
    meta,
    withoutBorder,
    placeholder,
    disabled,
    onInputChange,
    filterOption,
    isCity,
    isClearable = false,
    isSearchable = true,
    noOptionsMessage = null,
    defaultValue,
    customLayoutClasses,
    menuPortalTarget,
    menuPosition,
    menuIsOpen,
    isMulti = false,
    customOptionComponent,
    customSingleValueComponent,
    required,
    id,
    ariaLabel
  } = props

  const isError = meta.touched && meta.error

  // Ensure current value is included in options to prevent flickering
  // This is especially important for city selects where options are loaded async
  let finalOptions = options
  if (value && value.value !== undefined && value.label) {
    const valueExists = options && options.some((opt: any) => opt.value === value.value)
    if (!valueExists) {
      finalOptions = [value, ...(options || [])]
    }
  }

  return (
    <Layout
      required={required}
      customClasses={customLayoutClasses}
      title={title}
      meta={meta}
      id={id || name}
    >
      <ReactSelect
        aria-label={ariaLabel}
        inputId={ariaLabel ? undefined : id || name}
        menuIsOpen={menuIsOpen}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        options={finalOptions}
        isDisabled={disabled}
        styles={withoutBorder ? colourStylesWithoutBorder : colourStyles}
        onInputChange={onInputChange}
        hideSelectedOptions={true}
        components={{
          DropdownIndicator,
          Option: customOptionComponent || reactSelectComponents.Option,
          SingleValue: customSingleValueComponent || reactSelectComponents.SingleValue
        }}
        noOptionsMessage={() => (isCity ? 'Start typing at least 2 characters' : noOptionsMessage)}
        placeholder={placeholder || 'Select...'}
        isClearable={isClearable || isCity}
        isSearchable={isSearchable}
        filterOption={filterOption}
        isMulti={isMulti}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            neutral10: isError ? '#dc233b' : '#E6E6E6',
            primary25: 'rgba(243, 243, 243, 0.3)',
            placeholder: cssVarTextColors.placeholder
          }
        })}
      />
    </Layout>
  )
}

export default memo(Select)
